import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

export const Checkbox = ({checked, hasEntitiesChecked, onClick, onChange, small, userpilot, cy, disabled}) => {
	return (
		<StyledInput
			readOnly
			small={small}
			className={hasEntitiesChecked ? 'group-has-entities-checked' : ''}
			type="checkbox"
			checked={checked}
			onChange={onChange ? onChange : null}
			onClick={onClick ? onClick : null}
			data-userpilot={userpilot}
			data-cy={cy}
			disabled={disabled}
		></StyledInput>
	);
};

const StyledInput = Styled.input`
    box-sizing: border-box;
	cursor: pointer;
	height: ${props => (props.small ? '15px' : '18px')};
    width: ${props => (props.small ? '15px' : '18px')};
    margin:0;
    -webkit-appearance: none;
	-moz-appearance: none;
    appearance: none;
    border: solid 2px ${props => (props.theme.colors !== undefined ? props.theme.colors.veryLightGray : '#e6e6e6')};
    border-radius: 4px;
    transition: background-color 0.2s ease;
	background-color: ${props => (props.theme.colors ? props.theme.colors.white : '#fff')};
	&:enabled {
		&:hover, &:focus, &:checked {
			border: solid 2px ${props => (props.theme.colors ? props.theme.colors.forecastPurple : '#6e0fea')};
		}
	}
	&:checked {
		background-color: ${props => (props.disabled ? props.theme.colors.mediumLightGray : props.theme.colors.forecastPurple)};
		border-color: ${props => props.disabled && props.theme.colors.mediumLightGray};
	}
    &:after {
        box-sizing: unset;/*to overide the global box-sizing:inherit on all :after from the app*/
        content: '';
        display: block;
        width: ${props => (props.small ? '5px' : '6px')};
        height:  ${props => (props.small ? '8px' : '10px')};
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: translateX(-50%) rotate(40deg);
        position: relative;
        left: 50%;
        top:  -1px;
	}
    &.group-has-entities-checked {
        &:after {
            transform: translateX(-50%) rotate(90deg);
            border-bottom-style: none;
            top: -1px;
        }
    }
    &:focus{
        outline: none;
    }
`;

Checkbox.propTypes = {
	small: PropTypes.bool,
	/**
	 * The element is checked or not.
	 */
	checked: PropTypes.bool,

	/**
	 * If the checkbox represents multiple elements,
	 * and some or checked, some not.
	 */
	hasEntitiesChecked: PropTypes.bool,

	/**
	 * Callback of the input.
	 */
	onClick: PropTypes.func,
	onChange: PropTypes.func,

	userpilot: PropTypes.string,
	cy: PropTypes.string,
	disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
	checked: false,
	hasEntitiesChecked: false,
};
